import * as React from "react";
const SvgClear = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 6 6", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M5 5 1 1m4 0L1 5" }));
export default SvgClear;
